import { CLOCK_TYPE, ITime } from "../durationw-clock/durationw-clock.component";
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  styleUrls: ["durationw-time-dialog.component.scss"],
  templateUrl: "durationw-time-dialog.component.html"
})
export class DurationWTimeDialogComponent {
  userTime: ITime;
  color: string;
  hideMeridian: boolean;

  private VIEW_HOURS = CLOCK_TYPE.HOURS;
  private VIEW_MINUTES = CLOCK_TYPE.MINUTES;
  private currentView: CLOCK_TYPE = this.VIEW_HOURS;

  constructor(
    private dialogRef: MatDialogRef<DurationWTimeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.userTime = this.data.time;
    this.color = this.data.color;
    this.hideMeridian = this.data.hideMeridian;
  }

  public revert() {
    this.dialogRef.close(-1);
  }

  public submit() {
    this.dialogRef.close(this.userTime);
  }
}
